'use strict';

window.addEventListener('DOMContentLoaded', () => {
  //IntersectionObserver を設定する関数
  const setObserver = () => {
    //コールバック関数の定義
    const callback = (entries: any) => {
      //各 entry（IntersectionObserverEntry オブジェクト）に対して
      entries.forEach((entry: any) => {
        //監視対象の要素が領域内に入った場合の処理
        if (entry.isIntersecting) {
          //監視対象の要素（entry.target）に inView クラスを追加
          entry.target.dataset.view = 'true';
        } else {
          //監視対象の要素が領域外になった場合の処理
          //監視対象要素から inView クラスを削除
          // entry.target.classList.remove('inView');
        }
      });
    };

    //オプション
    const options = {
      //コールバック関数を呼び出すタイミングを指定
      threshold: [0.3, 0.75],
    };

    //引数にコールバック関数とオプションを指定してオブザーバーを生成
    const observer = new IntersectionObserver(callback, options);

    //監視対象の要素（target クラスを指定した要素）を全て取得
    const targets = document.querySelectorAll('.js-animeObj');

    //全ての監視対象要素を observe() メソッドに指定
    targets.forEach((elem) => {
      //observe() に監視対象の要素を指定
      observer.observe(elem);
    });
  };
  //上記関数の実行
  setObserver();
});
